<!--
  File name: DrawerItem.vue
  Program Description:
    - This component renders the drawer items set in the navigation bar of the
    system.
    - It allows the navigation drawer to set the icon and label of the page and
    navigate to a different page/form upon clicking the item.

-->

<template>
  <router-link
    :id="id"
    class="nav-link"
    :to="href"
  >
    <v-list-item
      link
      class="py-1"
      active-class="primary--text"
    >
      <v-list-item-action v-if="icon">
        <v-icon>{{ icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title :class="`text-wrap ${indent}`">
          {{ label }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </router-link>
</template>

<script>
export default {
  name: 'DrawerItem',
  props: {
    id: { type: String, default: '' },
    icon: { type: String, default: undefined },
    label: { type: String, default: undefined },
    href: { type: Object, default: undefined },
    indent: { type: String, default: undefined }
  }
}
</script>

<style scoped>
  .style {
    background-color: rgb(255, 255, 255);
    color: black;
  }
</style>
